import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { PricingDto } from '@dto/pricingDto';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PricingsService } from '@services/entity/pricings.service';
import { ToastService } from '@services/toast/toast.service';
import { plainToClass } from 'class-transformer';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ChargingStationByGroupDto } from '@dto/chargingStationByGroupDto';
import { UserDto } from '@dto/userDto';
import { UsersService } from '@services/entity/users.service';
import { FormService } from '@services/form/form.service';
import { BillingMethodEnum } from '@enums/billingMethodEnum.enum';
import { InvoiceItemDto } from '@dto/invoiceItemDto';
import { DeletePricingRequest } from '@dto/deletePricingRequest';
import { forkJoin } from 'rxjs';
import { OpenItemsActionEnum } from '@enums/openItemsActionEnum.enum';

@Component({
  selector: 'app-delete-pricing-dialog-content',
  templateUrl: './delete-pricing-dialog-content.component.html',
  styleUrls: ['./delete-pricing-dialog-content.component.scss']
})
export class DeletePricingDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'DeletePricingDialogContentComponent';

  public invoiceItems: InvoiceItemDto[] = [];
  public influencedUsers: UserDto[] = [];
  public influencedUserNamesDisplay: string
  public openItemsAction: OpenItemsActionEnum = OpenItemsActionEnum.LaterBilling;
  public shouldKeepAuth: boolean = true;
  public isTableReady: boolean = false;

  private _step: number = 1
  private _executed = false
  set step(value: number) {
    this._step = value
    if(value === 3 && !this._executed)
    {
      this.submit()
      this._executed = true
    } else if (value === 2 && this.influencedUsers.length === 0)
    {
      this.step++
    }
  }

  get step() : number {
    return this._step
  }

  constructor(
    public activeModal: NgbActiveModal,
    public dialog: NgbModal,
    private pricingsService: PricingsService,
    private spinnerService: NgxSpinnerService,
    private toastService: ToastService,
    injector: Injector) {
    super(activeModal, injector);
  }

  @Input() private pricingId: string;


  async ngOnInit() {
    super.ngOnInit();
    forkJoin({
      invoiceItems: this.pricingsService.getOpenInvoiceItemsOfPricing(this.pricingId),
      users: this.pricingsService.getUsersOfPricing(this.pricingId)
    }).subscribe({
      next: ({ invoiceItems, users }) => {
        this.invoiceItems = plainToClass(InvoiceItemDto, invoiceItems);
        this.isTableReady = true;

        this.influencedUsers = plainToClass(UserDto, users);
        const uniqueRecipientNames = [...new Set(this.influencedUsers.map(u => u.fullName))];
        this.influencedUserNamesDisplay = uniqueRecipientNames.join(', ');

        this.adjustInitialStep();
      },
      error: (error) => {
        this.isTableReady = true;
        console.error(error);
      }
    });
  }

  adjustInitialStep() {
    if (this.invoiceItems.length === 0 && this.influencedUsers.length > 0) {
      this.step = 2;
    } 
    if (this.invoiceItems.length === 0 && this.influencedUsers.length === 0) {
      this.step = 0;
    }
  }

  instantBilling() {
    this.openItemsAction = OpenItemsActionEnum.InstantBilling;
    this.step++;
  }

  noMoreBilling() {
    this.openItemsAction = OpenItemsActionEnum.NoMoreBilling;
    this.step++;
  }

  laterBilling() {
    this.step++;
  }

  keepAuth() {
    this.step++;
  }
  removeAuth() {
    this.shouldKeepAuth = false
    this.step++;
  }

  submit() {
    this.spinnerService.show()
    const request = new DeletePricingRequest();
    request.openItemsAction = this.openItemsAction;
    request.shouldKeepAuth = this.shouldKeepAuth;

    this.pricingsService.deletePricing(this.pricingId, request).subscribe(result => {
      this.spinnerService.hide()
      this.activeModal.close();
      this.toastService.success(`Tarif erfolgreich gelöscht.`);
    }, error => {
      this.spinnerService.hide()
      this.toastService.error(`Tarif konnte nicht gelöscht werden.`);
      this.activeModal.close();
    });
    this.activeModal.close();
    this.dialog.dismissAll();
  }

  parseDate(date: Date) {
    if (!date) return false
    return new Date(date).toLocaleDateString()
  }

  close() {
    this.activeModal.close();
  }
}
